import React from 'react';

class FixedInputBase extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
    };
    this.ee = props.ee;
    this.scrollBottom = props.scrollBottom;
    this.mobileHA = props.mobileHA;
    this.inputAnimation$ = props.inputAnimation$;

    this.inputBaseElem = null;
  }

  componentDidMount() {
    this.inputAnimation$
      .subscribe({
        next: v => {
          if (this.props.disabled === false) {
            if (v === 'input_enable') {
              if (!this.state.visible)
                this.setInputSize();
            }
            else if (v === 'input_in') {
              this.setState({ visible: true });
            }
          } else {
            if (v === 'input_out') {
              // this.setState({ visible: false }, () => this.setInputSize(0));
              this.fixInputSize();
              this.setState({ visible: false });
            }
          }
        }
      });
  }

  fixInputSize() {
    let elem = this.inputBoxElem;
    if (!elem) return;
    const height = getComputedStyle(elem).height;
    elem.style.height = height;
  }

  setInputSize(size) {
    let elem = this.inputBoxElem;
    if (!elem) return;
    if (size === 0) {
      Velocity(
        elem,
        { height: 0 },
        { duration: 350, delay: 350, mobileHA: this.mobileHA },
      );
    } else {
      let parent = elem.parentElement;
      let parentWidth = getComputedStyle(parent).width;
      let vParent = document.createElement('div');
      vParent.id = parent.id;
      vParent.style.width = `${parseInt(parentWidth)}px`;
      let vTarget = elem.cloneNode(true);
      vTarget.style.height = 'auto';
      vParent.appendChild(vTarget);
      document.getElementById('hu-input-sandbox').appendChild(vParent);
      const height = getComputedStyle(vTarget).height;
  
      Velocity(
        elem,
        { height: height },
        { duration: 350, mobileHA: this.mobileHA, complete: () => {
          this.inputAnimation$.next('input_in');
          setTimeout(() => {
            if (this.props.disabled === false) {  // ?
              elem.style.height = 'auto';
            } // ?
          }, 200);
        }},
      );
  
      this.scrollBottom(350);
      document.getElementById('hu-input-sandbox').innerHTML = '';
    }
  }

  render() {
    const { visible } = this.state;
    return (
      <div
        id="hu-footer-input-fixed"
        className={visible ? 'enabled' : ''}
        ref={elem => this.inputBaseElem = elem}
      >
        <div className="hu-input-box" ref={elem => this.inputBoxElem = elem}>
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default FixedInputBase;


// WEBPACK FOOTER //
// ./app/js/components/messenger/FixedInputBase.js